<template>
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
</template>

<script setup lang="ts">
import { useThrottleFn } from '@vueuse/core'

function resize() {
  // const fontSize = window.innerWidth / (1920 / 16)
  // document.documentElement.style.fontSize = fontSize + 'px'
}
onMounted(() => {
  window.addEventListener('resize', useThrottleFn(resize, 100))
})
</script>

<style>
html {
  font-size: 10Px;
}
@media (min-width: 1320px) {
  html {
    font-size: 11Px;
  }
}
@media (min-width: 1440px) {
  html {
    font-size: 12Px;
  }
}
@media (min-width: 1560px) {
  html {
    font-size: 13Px;
  }
}
@media (min-width: 1680px) {
  html {
    font-size: 14Px;
  }
}
@media (min-width: 1792px) {
  html {
    font-size: 15Px;
  }
}
@media (min-width: 1856px) {
  html {
    font-size: 15.5Px;
  }
}
@media (min-width: 1920px) {
  html {
    font-size: 16Px;
  }
}
@media (min-width: 2048px) {
  html {
    font-size: 17Px;
  }
}
@media (min-width: 2560px) {
  html {
    font-size: 21Px;
  }
}
</style>
